import _ from 'lodash-es';

angular
  .module('shbdeployer.kubernetes')
  .filter('kubernetesNodeStatusColor', function () {
    'use strict';
    return function (text) {
      var status = _.toLower(text);
      switch (status) {
        case 'готов':
          return 'success';
        case 'предупреждение':
          return 'warning';
        default:
          return 'danger';
      }
    };
  })
  .filter('kubernetesNodeConditionsMessage', function () {
    'use strict';
    return function (conditions) {
      if (conditions.MemoryPressure) {
        return 'На узле заканчивается оперативная память';
      }
      if (conditions.PIDPressure) {
        return 'На узле запущено слишком много процессов';
      }
      if (conditions.DiskPressure) {
        return 'На узле заканчивается место на диске';
      }
      if (conditions.NetworkUnavailable) {
        return 'Некорректная сетевая конфигурация узла';
      }
    };
  });
